import React from "react";
import { Tour, TourProps } from "antd";
import { useEffect, useState } from "react";

type UserTourProps = {
    steps: TourProps['steps'];
    pageKey: string;
}

export const UserTour = ({steps, pageKey} : UserTourProps) => {
    const [openTour, setOpenTour] = useState(false);

    useEffect(() => {
        const incompleteTours = JSON.parse(localStorage.getItem('incompleteTours') || '[]');
        if (incompleteTours.length === 0) localStorage.removeItem('incompleteTours');
        if (incompleteTours.includes(pageKey)) {
            setTimeout(() => {
                setOpenTour(true);
            }, 1000);
        }
    }, [])

    const finishTour = () => {
        const incompleteTours = JSON.parse(localStorage.getItem('incompleteTours') || '[]');
        const updatedTours = incompleteTours.filter((tour: string) => tour !== pageKey);
        localStorage.setItem('incompleteTours', JSON.stringify(updatedTours));
        setOpenTour(false);
    }
    return <Tour open={openTour} onClose={finishTour} steps={steps} disabledInteraction={true}/>
}